// Module
var code = " <md-button class=\"md-icon-button md-primary show-button\" ng-click=\"$ctrl.onShowPanel($event)\"> <md-icon md-svg-icon=\"settings\"></md-icon> <md-tooltip>{{'View Settings' | translate}}</md-tooltip> </md-button> ";
// Exports
export default code;